import { connect } from 'react-redux';

import { getFriendProfileAction } from '../../actions/friendProfileActions';
import { getFriendProfile } from '../../components/FriendProfile/friendProfileSelectors';
import FriendProfileView from '../../components/FriendProfile/friendProfileView.jsx';

const mapStateToProps = (state) => ({
  friendProfile: getFriendProfile(state),
});
const mapDispatchToProps = (dispatch) => ({
  loadFriendProfile: () => {
    dispatch(getFriendProfileAction());
  },
});

const FriendProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FriendProfileView);

export default FriendProfileContainer;
